export default "__VITE_ASSET__95f6dc0e__"